import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getAppDisplayName } from '../constants/apps';
import './Wiki.css';

const Wiki = () => {
    const { appName } = useParams();
    const navigate = useNavigate();
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const displayName = getAppDisplayName(appName);

    useEffect(() => {
        setLoading(true);
        setError(null);
        
        // Fetch markdown file from public/wiki directory
        fetch(`/wiki/${appName}.md`)
            .then(res => {
                if (!res.ok) {
                    throw new Error('Wiki page not found');
                }
                return res.text();
            })
            .then(text => {
                setContent(text);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, [appName]);

    if (loading) {
        return (
            <div className="wiki">
                <div className="wiki-header">
                    <h1>{displayName} Wiki</h1>
                </div>
                <div className="wiki-content">
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="wiki">
                <div className="wiki-header">
                    <h1>{displayName} Wiki</h1>
                    <button 
                        className="wiki-back-button"
                        onClick={() => navigate('/apps')}
                    >
                        Back to Apps
                    </button>
                </div>
                <div className="wiki-content">
                    <div className="alert-warning">
                        <p>Wiki page not found for {displayName}.</p>
                        <p>Create a file at <code>public/wiki/{appName}.md</code> to add content.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="wiki">
            <div className="wiki-header">
                <h1>{displayName} Wiki</h1>
                <div className="wiki-header-actions">
                    <button 
                        className="wiki-back-button"
                        onClick={() => navigate('/apps')}
                    >
                        Back to Apps
                    </button>
                </div>
            </div>
            <div className="wiki-content">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {content}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export default Wiki;
